import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UnverifiedCustomersComponent } from './unverified-customers.component';
import { AuthGuard } from '../../../../../core/services/authGuard';

const routes: Routes = [
  {
    path: 'manage/admin/unverified-customers',
    component: UnverifiedCustomersComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UnverifiedCustomersRoutingModule {}
